// extracted by mini-css-extract-plugin
export default {"meals":"AvailableMeals_meals__p1gei","meals-appear":"AvailableMeals_meals-appear__H65KA"};